import { Text, View } from 'react-native';
import type { AbaId } from '../store/types';
import { useDoc } from '../store/store';
import { ReceivedBoxes } from '../components/BoxCard';
import { Screen } from '../components/ui';
import { C, aba } from '../components/theme';
import { t } from '../lib/i18n';

/** Abas ainda em construção (Estudos, Bem-Estar): abrem em branco, mas já recebem caixas de Anotações. */
export default function EmBreve({ id, onBack }: { id: AbaId; onBack: () => void }) {
  const { boxes } = useDoc('anotacoes');
  const a = aba(id);
  return (
    <Screen title={a.nome} onBack={onBack}>
      <View style={{ alignItems: 'center', gap: 10, marginTop: 40, marginBottom: 10 }}>
        <Text style={{ fontSize: 56 }}>{a.icon}</Text>
        <Text style={{ color: C.text, fontSize: 18, fontWeight: '700' }}>{t('Em construção')}</Text>
        <Text style={{ color: C.sub, textAlign: 'center' }}>{a.desc}</Text>
      </View>
      <ReceivedBoxes boxes={boxes} abaId={id} />
    </Screen>
  );
}
